<template>
	<transition :name="transitionName" mode="out-in">
		<keep-alive><router-view /></keep-alive>
	</transition>
</template>

<script>
import userApi from '@/request/userApi';
const debug = process.env.NODE_ENV !== 'production';
export default {
	name: 'App',
	data() {
		return {
			transitionName: 'right_in'
		};
	},
	created() {
		let that = this;
		// 判断是否存在openid的cookies，测试时首次加载会写入固定值cookies，正式版会由将获取openid的code post进页面，再通过code获取openid，再写入cookies
		let isOpenIDKey = this.$cookies.isKey('OpenID');
		console.log('isOpenIDKey=>', isOpenIDKey);
		if (!isOpenIDKey) {
			if (debug) {
				this.$cookies.set('OpenID', 'oDcOv54-HL9VoWh1_Ukynkw4QvaM', '8D', '/wechat'); // 测试时直接写入固定openid。
			}
			/***正式时代码，不需要注释。 ***/
			let code = document.getElementById('code').value; // 获取POST进页面的code，若有code则页面没openid，需要通过code获取openid
			if (code == '') {
				// 判断是否存在code
				if (!debug) {
					// 正式环境，跳出页面获取CODE
					window.location.href = '//www.callmefix.net/wechat/LoginYunTuNew.aspx?redir=' + window.location.href; // 跳转获取拉取用户所需的code
				} else {
					// 测试环境，用固定值加载数据。
					this.initData();
				}
			} else {
				// 已存在code，直接通过code调用接口获取用户数据
				this.$store.dispatch('user/wechatLogin', {
					code: code,
					context: that
				});
			}
		} else {
			// cookies里存在openid，调用接口获取用户信息与地址信息
			this.initData();
		}
		this.getWxJsApiParams();
	},
	methods: {
		getWxJsApiParams() {
			// 启用微信jsapi
			userApi.getWxJsApiParams(window.location.href, 2).then(sucRes => {
        console.log('getWxJsApiParams',sucRes)
				wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: sucRes.data.appid,
					timestamp: parseInt(sucRes.data.timestamp),
					nonceStr: sucRes.data.nonceStr,
					signature: sucRes.data.signature,
					jsApiList: ['getLocation', 'chooseWXPay', 'openLocation', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage','updateAppMessageShareData','updateTimelineShareData','chooseCard','addCard','openCard','onMenuShareTimeline','onMenuShareAppMessage','onMenuShareQQ','onMenuShareWeibo','onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
				});
			});
		},
		initData() {
			let OpenID = this.$cookies.get('OpenID');
			console.log('initData=>', OpenID);
			// cookies里存在openid，调用接口获取用户信息与地址信息
			this.$store.commit('user/setH5LoginInfo', { openid: OpenID });
			this.$store.dispatch('user/getUserData');
			this.$store.dispatch('ticket/getDefaultAddress', OpenID);
		}
	}
};
</script>

<style lang="less">
@import './style/variable.less';
@import './style/reset.less';
@import './style/public.less';
@import './style/css/iconfont.css';

#app {
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue